module.exports = __webpack_public_path__ + "static/media/logout.4772a78d.svg";